import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import CategoryPicker from "./CategoryPicker";
import { MapPin, Search } from "lucide-react";

export default function SearchBar({ initialCategory = "", initialLocation = "", dark = false }) {
  const [cats, setCats] = useState([]);
  const [category, setCategory] = useState(initialCategory || "all");
  const [location, setLocation] = useState(initialLocation);
  const nav = useNavigate();

  useEffect(() => { api.get("/categories").then((r) => setCats(r.data)).catch(() => {}); }, []);
  useEffect(() => { setCategory(initialCategory || "all"); setLocation(initialLocation); }, [initialCategory, initialLocation]);

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (category && category !== "all") p.set("category", category);
    if (location.trim()) p.set("location", location.trim());
    nav(`/search?${p.toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="search-bar"
      className={`grid md:grid-cols-[1fr_1fr_auto] gap-2 p-2 rounded-lg border ${dark ? "bg-zinc-900 border-zinc-800" : "bg-white border-zinc-200 shadow-sm"}`}>
      <CategoryPicker value={category} onChange={setCategory} categories={cats}
        allLabel="All services" className="h-12" testid="search-category" />
      <div className="relative">
        <MapPin className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
        <Input value={location} onChange={(e) => setLocation(e.target.value)}
          placeholder="Town or postcode" className="h-12 pl-9 bg-white text-black" data-testid="search-location" />
      </div>
      <Button type="submit" className="h-12 px-6 bg-[#FFCC00] hover:bg-[#E6B800] text-black font-semibold" data-testid="search-submit">
        <Search className="w-4 h-4 mr-2" /> Search
      </Button>
    </form>
  );
}
